module.exports = __webpack_public_path__ + "img/dropdown_arrow.5059e69b.svg";